module.exports = __webpack_public_path__ + "img/S-WEB-Goal-01.b242f9ab.png";